import { useAuth, overrideConfig } from '@/api/billing-primary'

export const service = {
    fetchInvoiceMonths: ({ usageAccountId }, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/invoice/${usageAccountId}/months`)
    },
    fetchSummaryStatistics: (params, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/summary/statistics', { params })
    },
    fetchSummarymonths: (params, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/summary/months', { params })
    },
    fetchSummaryRegions: (params, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/summary/regions', { params })
    },
    fetchSummaryWeeks: (params, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/summary/weeks', { params })
    },
    fetchSummaryDates: (params, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/summary/dates', { params })
    },
    fetchSummaryProducts: (params, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/summary/products', { params })
    },
    fetchSummaryCompareEstimated: (params, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/summary/compare/estimated', { params })
    },
    fetchSummaryComparePrevMonth: (params, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/summary/compare/prevmonth', { params })
    },
    fetchSummaryDetail: (params, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('v3/summarydetail', { params })
    },
    fetchCostByMonth: (params, serviceIdx) => {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v3/summary/month', { params })
    }
}

export default service
